import { withIcon } from './withIcon';

const TShirtSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 14.625L23.2969 12L19.9132 4.64775C19.6457 4.06664 19.1882 3.59409 18.616 3.30802L15 1.5H9L5.38392 3.30802C4.81177 3.59409 4.35422 4.06664 4.0868 4.64775L0.703125 12L6 14.625"
      stroke="currentColor"
      strokeWidth="1.40625"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 9.75V22.5H6V9.75"
      stroke="currentColor"
      strokeWidth="1.40625"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 11.25V14.625H9V11.25L10.875 12L12 10.125L13.125 12L15 11.25Z"
      stroke="currentColor"
      strokeWidth="1.40625"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 1.59074V2.24999C15 3.90684 13.6568 5.24999 12 5.24999C10.3432 5.24999 9 3.90684 9 2.24999V1.6027"
      stroke="currentColor"
      strokeWidth="1.40625"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 17.625H15"
      stroke="currentColor"
      strokeWidth="1.40625"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TShirt = withIcon(TShirtSvg);
